var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Tea } from '../sendLogV3/export';
import { logger } from '../logger';
import { createPortal, createBottomBanner, createSideBanner, createCookiePart } from './createDom';
import { getData } from './utils';
import { setCookie, getCookie } from '../cookieSDK/utils';
import { OptOut } from './module/optOut';
var COOKIE_KEY = 'Website_Cookie_Banner_Status';
var SETTING_KEY = 'Website_Cookie_Setting_Cache';
var CookieBanner = /** @class */ (function () {
    function CookieBanner(options) {
        var _this = this;
        var _a;
        if (!CookieBanner._instance) {
            this.options = options;
            this.bannerLock = false;
            this.settingLock = false;
            this.events = {};
            this.settingData = {};
            this.actionHistory = {};
            // 关闭setting时是否需要打开底部banner
            this.needShowBanner = true;
            CookieBanner._instance = this;
            if (this.options.needOptOut) {
                new OptOut(this.options.optOutOptions, (_a = this.options) === null || _a === void 0 ? void 0 : _a.thirdScripts);
                return;
            }
            // 创建底部banner
            this.renderDom();
            // 绑定事件
            this.addEvent();
            // 获取数据
            this.renderData(function (hasBannerDataAndShow) {
                // 显示banner
                if (_this.options.autoShowBanner !== false) {
                    var status_1 = getCookie(COOKIE_KEY);
                    if (!status_1) {
                        console.log('[Cookie Setting]: first visit');
                        if (hasBannerDataAndShow) {
                            _this.showBottomBanner();
                        }
                    }
                    else {
                        var parsedStatus = JSON.parse(status_1);
                        console.log('[Cookie Setting]:', parsedStatus.status);
                    }
                    // else {
                    //   let parsedStatus = JSON.parse(status);
                    //   let now = new Date().getTime();
                    //   let thirtenMonth = 13 * 30 * 24 * 60 * 60 * 1000;//超过13个月重新显示让用户接受或者拒绝
                    //   if ((now - parsedStatus.time) > thirtenMonth) {
                    //     console.log('[Cookie Setting]: time expired');
                    //     if (hasBannerDataAndShow) {
                    //       this.showBottomBanner();
                    //     }
                    //   } else {
                    //     console.log('[Cookie Setting]:', parsedStatus.status);
                    //   }
                    // }
                }
                // 触发完成事件
                _this.trigger('ready');
            });
        }
        return CookieBanner._instance;
    }
    // 渲染dom
    CookieBanner.prototype.renderDom = function () {
        this.portalDom = createPortal();
        this.bottomDoms = createBottomBanner();
        this.sideDoms = createSideBanner();
        // 添加
        this.portalDom.appendChild(this.bottomDoms.wrap);
        this.portalDom.appendChild(this.sideDoms.wrap);
    };
    // 渲染获取的动态数据
    CookieBanner.prototype.renderData = function (done) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, banner, setting, isSimpleBanner, needShowBanner, bannerObject, parsed, datas, localCache, localData_1, settingDatas_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getData(this.options.siteParam)];
                    case 1:
                        _a = _b.sent(), banner = _a.banner, setting = _a.setting;
                        isSimpleBanner = false;
                        needShowBanner = false;
                        // 设置banner描述
                        try {
                            if (banner) {
                                bannerObject = JSON.parse(banner.description);
                                isSimpleBanner = bannerObject.isSimple;
                                if (bannerObject.isSimple) {
                                    // 简单版本
                                    this.bottomDoms.isSimple = true;
                                    this.bottomDoms.wrap.className += ' cke_wp_simple';
                                    this.bottomDoms.btns.removeChild(this.bottomDoms.accept);
                                    this.bottomDoms.btns.removeChild(this.bottomDoms.reject);
                                    this.bottomDoms.btns.removeChild(this.bottomDoms.setting);
                                    this.bottomDoms.learnMore.setAttribute('href', bannerObject.learnMore);
                                }
                                else {
                                    // 复杂版本
                                    this.bottomDoms.isSimple = false;
                                    this.bottomDoms.btns.removeChild(this.bottomDoms.OK);
                                    this.bottomDoms.btns.removeChild(this.bottomDoms.learnMore);
                                    this.bottomDoms.inner.removeChild(this.bottomDoms.simpleTit);
                                }
                                parsed = bannerObject.description.replace(/\[(.*?)\]/ig, function (match) {
                                    match = match.substr(1, match.length - 2);
                                    match = match.split('@');
                                    var link = document.createElement('a');
                                    link.setAttribute('href', match[1] || '');
                                    link.setAttribute('target', '_blank');
                                    link.innerHTML = match[0] || '';
                                    return link.outerHTML;
                                });
                                this.bottomDoms.text.innerHTML = parsed;
                            }
                        }
                        catch (e) {
                            console.log('[cookie banner]: setting banner description error!', e);
                        }
                        // 设置setting内容
                        try {
                            if (setting) {
                                datas = JSON.parse(setting.description);
                                localCache = getCookie(SETTING_KEY);
                                if (localCache) {
                                    localData_1 = JSON.parse(localCache);
                                }
                                settingDatas_1 = {};
                                datas.types.forEach(function (it) {
                                    if (it.cookies) {
                                        it.cookies.forEach(function (ck) {
                                            if (localData_1) {
                                                // 合并本地的记录
                                                var local = localData_1[ck.key];
                                                if (local) {
                                                    ck.enable = local.enable;
                                                }
                                            }
                                            settingDatas_1[ck.key] = ck;
                                        });
                                    }
                                });
                                this.settingData = settingDatas_1;
                                // 顶部描述
                                this.sideDoms.description.innerHTML = datas.description;
                                // 遍历生成cookie政策
                                datas.types.forEach(function (item) {
                                    var box = createCookiePart(item, function (_a, enable) {
                                        var key = _a.key;
                                        _this.settingData[key].enable = enable;
                                        // 记录操作，关闭时还原
                                        if (_this.actionHistory[key]) {
                                            _this.actionHistory[key] += 1;
                                        }
                                        else {
                                            _this.actionHistory[key] = 1;
                                        }
                                    });
                                    _this.sideDoms.content.appendChild(box.box);
                                });
                            }
                        }
                        catch (e) {
                            console.log('[cookie setting]: setting cookie details error!', e);
                        }
                        if (isSimpleBanner) {
                            needShowBanner = !!banner;
                        }
                        else {
                            needShowBanner = (!!banner && !!setting);
                        }
                        if (done) {
                            done(needShowBanner);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieBanner.prototype.addEvent = function () {
        var _this = this;
        // Cookie setting 关闭事件
        this.sideDoms.close.addEventListener('click', function () {
            _this.hideSideBanner();
            if (_this.needShowBanner) {
                setTimeout(function () {
                    _this.showBottomBanner();
                }, 300);
            }
            // 还原刚刚的操作
            var switchs = _this.sideDoms.wrap.querySelectorAll('.cke_swc');
            switchs = __spreadArray([], switchs, true);
            var _loop_1 = function (key) {
                if (_this.actionHistory[key] % 2 !== 0) {
                    // 改变了，取反值即为还原
                    var bool = !_this.settingData[key].enable;
                    _this.settingData[key].enable = bool;
                    // 还原
                    var target = switchs.find(function (sw) { return sw.dataset.key === key; });
                    if (target.dataset.status === 'on') {
                        // 关闭
                        target.className = 'cke_swc cke_swc_c';
                        target.dataset.status = 'off';
                    }
                    else {
                        // 打开
                        target.className = 'cke_swc cke_swc_o';
                        target.dataset.status = 'on';
                    }
                }
            };
            for (var key in _this.actionHistory) {
                _loop_1(key);
            }
            _this.actionHistory = {};
        });
        // Cookie setting save事件，save之后，按照用户save的细节去管控cookie，不需要再弹窗底部banner让用户accept或者reject
        // 同理 accept是接受所有cookie，reject是拒绝所有非必要的cookie，save是根据用户选择去种植cookie
        this.sideDoms.save.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_cookie_setting', { component_text: JSON.stringify(_this.settingData), page_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [cookies_setting] log error', e);
            }
            ;
            _this.hideSideBanner();
            _this.trigger('save', __assign({}, _this.settingData));
            // 缓存一次
            setCookie(SETTING_KEY, JSON.stringify(_this.settingData));
            setCookie(COOKIE_KEY, "{\"status\": \"accepted\", \"code\": 1, \"time\": ".concat(new Date().getTime(), "}"));
            _this.actionHistory = {};
        });
        // 简版-ok
        this.bottomDoms.OK.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'ok', page_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [ok] touch log error', e);
            }
            ;
            _this.hideBottomBanner();
            setCookie(COOKIE_KEY, "{\"status\": \"accepted\", \"code\": 1, \"time\": ".concat(new Date().getTime(), "}"));
            _this.trigger('ok');
        });
        // 简版learn more
        this.bottomDoms.learnMore.addEventListener('click', function () {
            _this.trigger('learnMore');
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'learn_more', page_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [learn_more] touch log error', e);
            }
            ;
        });
        // 拒绝所有
        this.bottomDoms.reject.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'cookies_reject_all', page_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [cookies_reject_all] touch log error', e);
            }
            ;
            _this.hideBottomBanner();
            setCookie(COOKIE_KEY, "{\"status\": \"rejected\", \"code\": 2, \"time\": ".concat(new Date().getTime(), "}"));
            // 把所有选项都拒绝
            var keys = Object.keys(_this.settingData);
            keys.forEach(function (key) {
                _this.settingData[key].enable = false;
            });
            _this.changeSwitchValue();
            _this.trigger('rejectAll', __assign({}, _this.settingData));
            // 缓存一次
            setCookie(SETTING_KEY, JSON.stringify(_this.settingData));
        });
        // 接受所有
        this.bottomDoms.accept.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'cookies_accept_all', page_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [cookies_accept_all] touch log error', e);
            }
            ;
            _this.hideBottomBanner();
            setCookie(COOKIE_KEY, "{\"status\": \"accepted\", \"code\": 1, \"time\": ".concat(new Date().getTime(), "}"));
            // 把所有选项都接受
            var keys = Object.keys(_this.settingData);
            keys.forEach(function (key) {
                _this.settingData[key].enable = true;
            });
            _this.changeSwitchValue();
            _this.trigger('acceptAll', __assign({}, _this.settingData));
            // 缓存一次
            setCookie(SETTING_KEY, JSON.stringify(_this.settingData));
        });
        // Cookie Setting 点击事件
        this.bottomDoms.setting.addEventListener('click', function () {
            // 埋点上报
            try {
                Tea.sendLogV3('acv_button_touch', { component_text: 'cookies_setting' });
            }
            catch (e) {
                logger.error('cookie-banner', 'send [cookies_setting] touch log error', e);
            }
            ;
            _this.hideBottomBanner();
            setTimeout(function () {
                _this.showSideBanner();
            }, 300);
        });
    };
    CookieBanner.prototype.changeSwitchValue = function () {
        var _this = this;
        try {
            var switchs_1 = this.sideDoms.wrap.querySelectorAll('.cke_swc');
            switchs_1 = __spreadArray([], switchs_1, true);
            var settings = Object.keys(this.settingData);
            settings.forEach(function (key) {
                var target = switchs_1.find(function (sw) { return sw.dataset.key === key; });
                if (target) {
                    if (_this.settingData[key].enable) {
                        // 打开
                        target.className = 'cke_swc cke_swc_o';
                        target.dataset.status = 'on';
                    }
                    else {
                        // 关闭
                        target.className = 'cke_swc cke_swc_c';
                        target.dataset.status = 'off';
                    }
                }
            });
        }
        catch (_) {
            console.log('[cookie setting]: change switch value error', _);
        }
    };
    // 显示底部banner
    CookieBanner.prototype.showBottomBanner = function () {
        var _this = this;
        if (this.bannerLock) {
            return;
        }
        this.bannerLock = true;
        if (this.bottomDoms.isSimple) {
            this.bottomDoms.wrap.className = 'cke_wp cke_wp_simple';
        }
        else {
            this.bottomDoms.wrap.className = 'cke_wp';
        }
        setTimeout(function () {
            _this.bottomDoms.wrap.className += ' cke_b_s';
            _this.bannerLock = false;
        }, 10);
    };
    // 隐藏底部banner
    CookieBanner.prototype.hideBottomBanner = function () {
        var _this = this;
        if (this.bannerLock) {
            return;
        }
        this.bannerLock = true;
        if (this.bottomDoms.isSimple) {
            this.bottomDoms.wrap.className = 'cke_wp cke_wp_simple cke_b_hd';
        }
        else {
            this.bottomDoms.wrap.className = 'cke_wp cke_b_hd';
        }
        setTimeout(function () {
            if (_this.bottomDoms.isSimple) {
                _this.bottomDoms.wrap.className = 'cke_wp cke_wp_simple cke_none';
            }
            else {
                _this.bottomDoms.wrap.className = 'cke_wp cke_none';
            }
            _this.bannerLock = false;
        }, 320);
    };
    // 显示侧边banner
    CookieBanner.prototype.showSideBanner = function (needShowBanner) {
        var _this = this;
        if (needShowBanner === void 0) { needShowBanner = true; }
        if (this.settingLock) {
            return;
        }
        this.needShowBanner = needShowBanner;
        this.settingLock = true;
        this.sideDoms.wrap.className = 'cke_side';
        setTimeout(function () {
            _this.sideDoms.wrap.className += ' cke_side_s';
            _this.settingLock = false;
        }, 10);
    };
    // 隐藏侧边banner
    CookieBanner.prototype.hideSideBanner = function () {
        var _this = this;
        if (this.settingLock) {
            return;
        }
        this.settingLock = true;
        this.sideDoms.wrap.className = 'cke_side';
        setTimeout(function () {
            _this.sideDoms.wrap.className += ' cke_side_hd';
            _this.settingLock = false;
        }, 320);
    };
    // 监听事件
    CookieBanner.prototype.listen = function (event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    };
    // 触发事件
    CookieBanner.prototype.trigger = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.events[event]) {
            this.events[event].forEach(function (fn) {
                if (fn && typeof fn === 'function') {
                    fn.apply(void 0, args);
                }
            });
        }
    };
    // 获取配置数据
    CookieBanner.prototype.getSetting = function () {
        return this.settingData;
    };
    // 获取状态
    CookieBanner.prototype.getStatus = function () {
        var status = getCookie(COOKIE_KEY);
        if (!status) {
            return { status: 'first visit', code: 0, time: null };
        }
        return JSON.parse(status);
    };
    return CookieBanner;
}());
export { CookieBanner };
//# sourceMappingURL=index.js.map